import SingleUserRow from 'components/molecules/FollowModal/SingleUserRow';
import { UserData } from 'interfaces/UserData.interface';
import React from 'react';
const user0 = require('assets/Profile/buku_default_avatar.png');

interface IOwnersCollectorsProps {
  user: UserData;
}

const OwnersCollectors = ({ user }: IOwnersCollectorsProps) => {
  return (
    <div className="owners">
      <h4>Creator</h4>
      <div>
        <SingleUserRow
          avatarSrc={user.avatar || user0}
          username={user.username}
          userId={user.id}
          data={user}
        />
      </div>
      {/* <div className="owners">
        <h4>Collectors</h4>
        <div>
          <SingleUserRow
            avatarSrc={user.avatar || user0}
            username={user.username}
            userId={user.id}
            data={user}
          />
        </div>
      </div> */}
    </div>
  );
};

export default OwnersCollectors;
